import React from 'react';

export default function Booking() {
  return <main id="main-content" className="booking-page"><div className="booking-card"><aside className="booking-profile"><p>Khoa Luong</p><h1>Let’s chat.</h1><span>◷ &nbsp; 30 minutes</span></aside><div className="booking-calendar"><h2>Find a time.</h2><a className="request-button" href="https://cal.com/khoamluong/30min" target="_blank" rel="noopener noreferrer">Choose a time ↗</a></div></div></main>;
}
